import React from 'react';

type Props = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  timezone?: string;
  required?: boolean;
  compact?: boolean;
};

export const SessionDateTimePicker: React.FC<Props> = ({
  label,
  value,
  onChange,
  timezone,
  required = false,
  compact = false,
}) => {
  const inputValue = value || '';
  const inputClass = compact
    ? 'h-[50px] min-w-0 flex-1 rounded-[13px] border-[1.5px] border-slate-200 bg-white px-[15px] text-[15px] font-semibold text-slate-900 transition-all focus:border-indigo-500 focus:outline-none focus:ring-4 focus:ring-indigo-500/10'
    : 'min-w-0 flex-1 rounded-xl border-2 border-slate-200 bg-white px-4 py-2.5 font-bold text-slate-900 transition-all focus:border-indigo-500 focus:outline-none focus:ring-4 focus:ring-indigo-500/10';

  return (
    <div>
      {label ? (
        <label className="mb-2 block text-[11px] font-bold uppercase tracking-[0.08em] text-slate-400">{label}</label>
      ) : null}
      <div className="flex items-center gap-2">
        <input
          type="datetime-local"
          value={inputValue}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          className={inputClass}
        />
        {value ? (
          <button
            type="button"
            onClick={() => onChange('')}
            className="shrink-0 rounded-[13px] border-[1.5px] border-slate-200 px-3 py-2.5 text-sm font-bold text-slate-500 transition-colors hover:border-slate-300 hover:bg-slate-50"
          >
            Effacer
          </button>
        ) : null}
      </div>
      {timezone && (
        <div className="mt-1 text-xs font-medium text-slate-400 ml-1">{timezone}</div>
      )}
      {required && !value && <div className="mt-2 text-xs font-medium text-amber-600">Date et heure requises.</div>}
    </div>
  );
};
